import React, { useEffect, useState, useRef, createElement, Component } from 'react';
import { cn } from '@/lib/utils';
import { useMotionValue, useTransform, animate } from 'framer-motion';
import { CheckCircle2, Star, Heart, CreditCard, Users, Ticket, ArrowRight, MessageCircle, X, ThumbsUp, GraduationCap, Zap, ShieldCheck, Flower2, Leaf, Sparkles, Medal } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
// --- Types ---
declare global {
  interface Window {
    fbq: any;
  }
}
// --- Constants & Data ---
const CHECKOUT_URL = 'https://novalibros.shop/cart/48530262130937:1';
const MAIN_IMAGE = 'https://cdn.magicpatterns.com/uploads/npQgkL51ifKiAYU7NpRrzU/COSMETICA_VIVA_PNG.png';
const ALUMNI_IMAGES = ['https://cdn.magicpatterns.com/uploads/jGbzK2jqd1cjzTEwbnjfDN/ChatGPT_Image_6_jul_2026,_02_08_56_a.m..webp', 'https://cdn.magicpatterns.com/uploads/fb6fR1etRdDY6WTgaK199D/ChatGPT_Image_5_jul_2026,_07_05_37_p.m..webp', 'https://cdn.magicpatterns.com/uploads/d46EQ218ProhA7ndKPsRa8/ChatGPT_Image_5_jul_2026,_06_42_45_p.m..webp', 'https://cdn.magicpatterns.com/uploads/2TEm864tfTyExk5KvcxjDM/ChatGPT_Image_5_jul_2026,_07_19_20_p.m..webp', 'https://cdn.magicpatterns.com/uploads/oweg51D8xkCNoDkYba1KaA/ChatGPT_Image_5_jul_2026,_06_39_13_p.m..webp'];
const BONUSES = [{
  id: 1,
  img: 'https://cdn.magicpatterns.com/uploads/gupmjWjTaHKzvZynE789Sc/BONO_1_LIBRO.png',
  title: 'Cabello Vivo',
  description: 'Fórmulas naturales para un cabello fuerte, brillante y saludable desde la raíz.'
}, {
  id: 2,
  img: 'https://cdn.magicpatterns.com/uploads/xmxtvNAwGKzxKNY9ifZECj/BONO_2_LIBRO.png',
  title: 'Maquillaje Vivo',
  description: 'Crea tu propio maquillaje mineral y natural libre de tóxicos y químicos pesados.'
}, {
  id: 3,
  img: 'https://cdn.magicpatterns.com/uploads/edw9sA2n6EFLQRzRR6xmdC/BONO_3_LIBRO.png',
  title: 'Shampoo Vivo',
  description: 'Domina el arte del shampoo sólido y líquido adaptado a cada tipo de necesidad.'
}, {
  id: 4,
  img: 'https://cdn.magicpatterns.com/uploads/b47Fkrfh6L5z3dXV1py2kg/BONO_4_LIBRO.png',
  title: 'Perfumes Capilares',
  description: 'Fragancias botánicas que refrescan, cuidan y embellecen tu cabello todo el día.'
}, {
  id: 5,
  img: 'https://cdn.magicpatterns.com/uploads/kJTxrUCwgBoc3JNdXJjDDa/BONO_5_LIBRO.png',
  title: 'Protección Natural',
  description: 'Elabora tus propios protectores solares y pastas dentales 100% biodegradables.'
}, {
  id: 6,
  img: 'https://cdn.magicpatterns.com/uploads/vs3CEyEMj6qzDcdTCyNe5f/BONO_6_LIBRO.png',
  title: 'Alivio Natural',
  description: 'Ungüentos y pomadas artesanales para calmar dolores y cuidar la piel de tu familia.'
}, {
  id: 7,
  img: 'https://cdn.magicpatterns.com/uploads/hsHYxByebbeN3LRkzf3GYC/BONO_7_LIBRO.png',
  title: 'Mirada Viva',
  description: 'Fortalece y embellece tus pestañas y cejas con sérums botánicos de alto impacto.'
}, {
  id: 8,
  img: 'https://cdn.magicpatterns.com/uploads/2KMF1pLfoas2dhC79MqwQp/BONO_8_LIBRO.png',
  title: 'Modelado Capilar',
  description: 'Geles y cremas de peinar naturales para definir tus rizos y controlar el frizz.'
}, {
  id: 9,
  img: 'https://cdn.magicpatterns.com/uploads/dhZMY5rbQXwpLFSdRHBBrJ/ChatGPT_Image_21_ago_2026,_09_28_27_p.m..png',
  title: 'Jabones Naturales',
  description: 'Guía para realizar jabones aromáticos, medicinales y para el cuidado de tu piel.'
}, {
  id: 10,
  img: 'https://cdn.magicpatterns.com/uploads/kjwtTqUuZScMKFavuTijit/ChatGPT_Image_21_ago_2026,_09_28_24_p.m..png',
  title: 'Velas Naturales',
  description: 'Recetario para la creación de velas naturales con aromas que inspiran.'
}, {
  id: 11,
  img: 'https://cdn.magicpatterns.com/uploads/4Uk5PkgAB3PVSKakispQH1/ChatGPT_Image_21_ago_2026,_09_28_29_p.m..png',
  title: 'Maceraciones y Aceites',
  description: 'Recetario para extraer lo mejor de las plantas para tu bienestar.'
}, {
  id: 12,
  badge: 'Bono Especial',
  img: 'https://cdn.magicpatterns.com/uploads/abFwPh4aqLuwcfNFSbvmcH/ChatGPT_Image_21_ago_2026,_10_29_07_p.m..png',
  title: 'Lista de Proveedores',
  description: 'Tu guía confiable para encontrar insumos de calidad en Argentina para tus creaciones naturales.'
}];
const INITIAL_TESTIMONIALS = [{
  id: 1,
  name: 'Carmen G.',
  city: 'Rosario',
  text: 'Chicas, a mis 50 y pico nunca me imaginé haciendo mis propios cosméticos. ¡Miren lo que es esta crema corporal! Tiene una textura que es una pinturita, te deja la piel un lujo. Pensé que iba a ser un lío, pero fue re fácil prepararla y los insumos los conseguí al toque gracias a la lista. ¡Anímense que es un viaje de ida!',
  rating: 5,
  likes: 12,
  date: 'hace 4 días',
  avatar: 'https://cdn.magicpatterns.com/uploads/dkg7hcEgmf515qUh6TPz3Z/image.png',
  image: 'https://cdn.magicpatterns.com/uploads/cekCgZ6VepjYKoG2KYWNED/Captura_de_pantalla_2026-08-23_025321.png'
}, {
  id: 2,
  name: 'Mariela',
  city: 'Córdoba',
  text: '¡Ya armé mi primer lote de cremas faciales para vender! Le puse "MIKA" a mi marca. La verdad que el curso es un golazo, te tira la posta con los ingredientes y las proporciones. Estoy re chocha con cómo quedaron, súper profesionales.',
  rating: 5,
  likes: 8,
  date: 'hace 5 días',
  avatar: 'https://cdn.magicpatterns.com/uploads/sdoqWXDaGMnsENyXGeSq86/image.png',
  image: 'https://cdn.magicpatterns.com/uploads/njCLyQMbPt3Und3sShXt79/Captura_de_pantalla_2026-08-23_025327.png'
}, {
  id: 3,
  name: 'maria mercedes',
  city: 'Buenos Aires',
  text: 'Me mandé a hacer unos sérums faciales y miren lo pro que quedaron. Alta facha los frasquitos. La receta del sérum es una locura, te deja la piel re suavecita. Mil gracias por la data, valió cada peso la inversión.',
  rating: 5,
  likes: 15,
  date: 'hace 1 semana',
  avatar: 'https://cdn.magicpatterns.com/uploads/nUE7i5ETko2duvdpTJT47c/image.png',
  image: 'https://cdn.magicpatterns.com/uploads/keCzZ7DBLYauQETiMzT5jc/Captura_de_pantalla_2026-08-23_025334.png'
}, {
  id: 4,
  name: 'Pato',
  city: 'Mendoza',
  text: 'la verdad q x el precio es un regalo. los bonos estan buenisimos tmb. el de shampoo me cambio el pelo mal',
  rating: 5,
  likes: 21,
  date: 'hace 2 semanas',
  avatar: 'https://cdn.magicpatterns.com/uploads/kWofqSLbVTbMnCwQq668SF/image.png'
}, {
  id: 5,
  name: 'Vane',
  city: 'Salta',
  text: 'ya empece a vender mis propios tonicos a mis amigas y estan chochas. una oportunidad de oro para arrancar algo propio',
  rating: 5,
  likes: 34,
  date: 'hace 2 semanas',
  avatar: 'https://cdn.magicpatterns.com/uploads/mTKorJuksAvzwCUDpa41vU/image.png'
}];
const ARG_CITIES = ['CABA', 'Córdoba', 'Rosario', 'Mendoza', 'Salta', 'Tucumán', 'La Plata', 'Mar del Plata', 'Neuquén', 'Posadas'];
const ARG_NAMES = ['María', 'Florencia', 'Agustina', 'Lucía', 'Camila', 'Valentina', 'Martina', 'Paula', 'Silvia', 'Gabriela'];
// --- Components ---
const Button = ({
  children,
  className = '',
  onClick,
  showShine = false
}: {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  showShine?: boolean;
}) => <button onClick={onClick || (() => window.location.href = CHECKOUT_URL)} className={`w-full py-4 px-6 rounded-xl font-bold text-lg transition-all transform hover:scale-105 active:scale-95 shadow-lg flex items-center justify-center gap-2 relative overflow-hidden ${className}`} data-id="element-0" data-mp="3i3mu2ipdol3m">
    {showShine && <motion.div initial={{
    x: '-150%'
  }} animate={{
    x: '150%'
  }} transition={{
    repeat: Infinity,
    duration: 2.5,
    ease: 'linear',
    repeatDelay: 3
  }} className="absolute inset-0 w-full h-full bg-gradient-to-r from-transparent via-white/30 to-transparent skew-x-[-25deg] pointer-events-none" data-id="element-1" data-mp="3d4jp0y9eeevn" />}
    <span className="relative z-10 flex items-center justify-center gap-2" data-id="element-2" data-mp="2pfhahza2925d">
      {children}
    </span>
  </button>;
const Counter = ({
  target,
  duration
}: {
  target: number;
  duration: number;
}) => {
  const count = useMotionValue(0);
  const rounded = useTransform(count, latest => {
    const val = Math.round(latest);
    return val >= 1000 ? `+${val.toLocaleString('de-DE')}` : `+${val}`;
  });
  useEffect(() => {
    const controls = animate(count, target, {
      duration
    });
    return controls.stop;
  }, [count, target, duration]);
  return <motion.span data-id="element-3" data-mp="2vu7ng0mnmrps">{rounded}</motion.span>;
};
const Section = ({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) => <section className={cn(`py-12 px-6 max-w-4xl mx-auto ${className}`, 'pt-[9px] pb-[9px]', 'pt-[0px] pb-[0px] mt-[0px] mb-[0px]')} data-id="element-4" data-mp="2lyw8bh7c3ihi">
    {children}
  </section>;
const CountdownText = () => {
  const [timeLeft, setTimeLeft] = useState(600); // 10 minutes in seconds
  useEffect(() => {
    if (timeLeft <= 0) return;
    const timer = setInterval(() => {
      setTimeLeft(prev => prev - 1);
    }, 1000);
    return () => clearInterval(timer);
  }, [timeLeft]);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  return <span className="text-sm font-black text-[#9D4D60] tabular-nums" data-id="element-5" data-mp="1yamr6sl2fiwp">
      {minutes}:{seconds < 10 ? `0${seconds}` : seconds}
    </span>;
};
export function App() {
  const [selectedOffer, setSelectedOffer] = useState('premium');
  const [coupons, setCoupons] = useState(7);
  const [viewers, setViewers] = useState(12);
  const [purchaseNotify, setPurchaseNotify] = useState<{
    name: string;
    city: string;
  } | null>(null);
  const [comments, setComments] = useState(INITIAL_TESTIMONIALS);
  const [studentCount, setStudentCount] = useState(1101);
  const [newComment, setNewComment] = useState('');
  const [newRating, setNewRating] = useState(5);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [visibleComments, setVisibleComments] = useState(5);
  const [showSticky, setShowSticky] = useState(false);
  const [stickyInfoIndex, setStickyInfoIndex] = useState(0);
  const purchaseSectionRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    // --- Meta Pixel Code ---
    const pixelId = '2633544103706749';
    if (!window.fbq) {
      window.fbq = function () {
        window.fbq.callMethod ? window.fbq.callMethod.apply(window.fbq, arguments) : window.fbq.queue.push(arguments);
      };
      if (!window._fbq) window._fbq = window.fbq;
      window.fbq.push = window.fbq;
      window.fbq.loaded = !0;
      window.fbq.version = '2.0';
      window.fbq.queue = [];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
      window.fbq('init', pixelId);
    }
    window.fbq('track', 'PageView');
    // --- End Meta Pixel Code ---
    const couponInterval = setInterval(() => {
      setCoupons(Math.floor(Math.random() * (7 - 4 + 1)) + 4);
    }, 45000);
    const viewerInterval = setInterval(() => {
      setViewers(Math.floor(Math.random() * (15 - 8 + 1)) + 8);
    }, 10000);
    const notifyInterval = setInterval(() => {
      const name = ARG_NAMES[Math.floor(Math.random() * ARG_NAMES.length)];
      const city = ARG_CITIES[Math.floor(Math.random() * ARG_CITIES.length)];
      setPurchaseNotify({
        name,
        city
      });
      setTimeout(() => setPurchaseNotify(null), 5000);
    }, 15000);
    const studentInterval = setInterval(() => {
      setStudentCount(prev => prev + 1);
    }, 30000);
    const stickyInterval = setInterval(() => {
      setStickyInfoIndex(prev => prev === 0 ? 1 : 0);
    }, 4000);
    const handleScroll = () => {
      if (window.scrollY > 600) {
        setShowSticky(true);
      } else {
        setShowSticky(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
      clearInterval(couponInterval);
      clearInterval(viewerInterval);
      clearInterval(notifyInterval);
      clearInterval(studentInterval);
      clearInterval(stickyInterval);
    };
  }, []);
  const scrollToPurchase = () => {
    purchaseSectionRef.current?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const handlePostComment = () => {
    if (!newComment.trim()) return;
    const comment = {
      id: Date.now(),
      name: 'Usuario',
      city: 'Argentina',
      text: newComment,
      rating: newRating,
      likes: 0,
      date: 'ahora mismo'
    };
    setComments([comment, ...comments]);
    setNewComment('');
    setShowSuccessModal(true);
  };
  const today = new Date().toLocaleDateString('es-AR', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  });
  return <div className="min-h-screen bg-[#FDF2F2] text-slate-800 overflow-x-hidden" data-id="element-6" data-mp="33cr5opo15f8k">
      {/* Meta Pixel Noscript */}
      <noscript data-id="element-7" data-mp="2pm5lmxmuaz93">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=2633544103706749&ev=PageView&noscript=1" alt="" data-id="element-8" data-mp="2pkkrva8cnkca" />
      </noscript>

      {/* Trust Banner */}
      <div className="bg-white/40 border-b border-pink-100 py-1.5" data-id="element-9" data-mp="3hc09sqyyoiw6">
        <div className="max-w-4xl mx-auto px-4 flex flex-nowrap whitespace-nowrap text-[7px] md:text-[9px] font-semibold uppercase tracking-[0.2em] text-[#9D4D60] items-center justify-center md:gap-6 gap-[2px]" data-id="element-10" data-mp="3m41u906a9fxa">
          <div className="flex items-center gap-1" data-id="element-11" data-mp="15q85g8xkme9q">
            <GraduationCap size={10} className="text-[#D4AF37]" data-id="element-12" data-mp="15nlzgdqbw6tm" />
            <span data-id="element-13" data-mp="1kd1ewxkespu0">
              <Counter target={1000} duration={5} data-id="element-14" data-mp="1kdkyeippjma5" /> Alumnos
            </span>
          </div>

          <Flower2 size={8} className="text-[#D4AF37] opacity-40" data-id="element-15" data-mp="1fg1g97pw2pcx" />

          <div className="flex items-center gap-1" data-id="element-16" data-mp="rqqb7e1ia8sz">
            <Zap size={10} className="text-[#D4AF37]" data-id="element-17" data-mp="rri6enr6y4iq" />
            <span data-id="element-18" data-mp="mrvuchn3mubi">Acceso Inmediato</span>
          </div>

          <Flower2 size={8} className="text-[#D4AF37] opacity-40" data-id="element-19" data-mp="11nlba1dfgh9d" />

          <div className="flex items-center gap-1" data-id="element-20" data-mp="11ls0c9vs7avk">
            <ShieldCheck size={10} className="text-[#D4AF37]" data-id="element-21" data-mp="woid90vv7baw" />
            <span data-id="element-22" data-mp="2d306p0pzn12d">Garantía 7 Días</span>
          </div>
        </div>
      </div>

      {/* Header */}

      {/* Validity Banner */}

      {/* Hero Section */}
      <Section className="text-center pt-12 pb-8" data-id="element-23" data-mp="283f66lv66knj">
        <div className="pt-[7px] pb-[7px] mt-[3px] mb-[3px]" data-id="element-24" data-mp="hn36p6un9ljz">
          <h1 className="text-xs md:text-sm font-bold tracking-[0.4em] mb-2 text-[#9D4D60] opacity-80" data-id="element-25" data-mp="howeipgzubtk">
            BIENVENIDA A
          </h1>
          <div className="relative inline-block" data-id="element-26" data-mp="qmzz9jk5n4kb">
            <span className="text-3xl md:text-5xl font-serif font-bold tracking-tight bg-gradient-to-r from-[#B76E79] via-[#E1B1B9] to-[#D4AF37] bg-clip-text text-transparent animate-pulse" data-id="element-27" data-mp="qm6q6bxq42z0">
              COSMÉTICA VIVA
            </span>
            <div className="absolute -top-2 -right-4 text-[#D4AF37] animate-bounce" data-id="element-28" data-mp="15kio0lwu1hrr">
              ✨
            </div>
            <div className="absolute -bottom-1 -left-2 text-[#D4AF37] animate-pulse delay-700" data-id="element-29" data-mp="1ab8rtupm1ckc">
              ✨
            </div>
          </div>
        </div>

        
        <div className="space-y-2" data-id="element-30" data-mp="1jc704p73068q">
          <h2 className="text-2xl md:text-3xl font-serif italic text-[#2D5A27] leading-tight max-w-2xl mx-auto pt-[0px] pb-[0px] mt-[0px] mb-[0px] tracking-tight" data-id="element-31" data-mp="1jd882ksswcm8">
            Creá tu propia cosmética natural desde casa, aunque empieces desde
            cero.
          </h2>
          <p className="md:text-base font-medium uppercase tracking-[0.2em] opacity-90 pt-[0px] pb-[0px] pl-[0px] pr-[0px] mt-[0px] mb-[0px] ml-[0px] mr-[0px] text-[#47060E] text-[9px]" data-id="element-32" data-mp="1tfkn553ohatz">
            MÁS DE 300 RECETAS NATURALES PASO A PASO
          </p>
        </div>

        <div className="mb-6 cursor-pointer relative max-w-md mx-auto group" onClick={scrollToPurchase} data-id="element-33" data-mp="1khs69wib5v4h">
          {/* Subtle Floral Decorations */}
          <div className="absolute inset-0 pointer-events-none z-0" data-id="element-34" data-mp="2c7mvlt661kt5">
            <motion.div animate={{
            y: [0, -15, 0],
            rotate: [0, 10, 0],
            opacity: [0.3, 0.6, 0.3]
          }} transition={{
            duration: 5,
            repeat: Infinity,
            ease: 'easeInOut'
          }} className="absolute -top-6 -left-4 text-[#B76E79]" data-id="element-35" data-mp="27fn0ce11jg2w">
              <Flower2 size={28} strokeWidth={1.5} data-id="element-36" data-mp="2v4xuvdrsse8l" />
            </motion.div>

            <motion.div animate={{
            y: [0, 15, 0],
            rotate: [0, -15, 0],
            opacity: [0.2, 0.5, 0.2]
          }} transition={{
            duration: 6,
            repeat: Infinity,
            ease: 'easeInOut',
            delay: 1
          }} className="absolute top-1/4 -right-6 text-[#2D5A27]" data-id="element-37" data-mp="t7xd0ocp81po">
              <Leaf size={24} strokeWidth={1.5} data-id="element-38" data-mp="ogfc20aoe14p" />
            </motion.div>

            <motion.div animate={{
            scale: [1, 1.2, 1],
            opacity: [0.2, 0.4, 0.2]
          }} transition={{
            duration: 4,
            repeat: Infinity,
            ease: 'easeInOut',
            delay: 0.5
          }} className="absolute bottom-1/4 -left-8 text-[#D4AF37]" data-id="element-39" data-mp="ahpfqmvok5he">
              <Sparkles size={20} data-id="element-40" data-mp="5htc4oqwag2d" />
            </motion.div>

            <motion.div animate={{
            y: [0, -10, 0],
            rotate: [0, 20, 0],
            opacity: [0.3, 0.6, 0.3]
          }} transition={{
            duration: 7,
            repeat: Infinity,
            ease: 'easeInOut',
            delay: 2
          }} className="absolute -bottom-4 right-4 text-[#E1B1B9]" data-id="element-41" data-mp="5kfjoodscvkl">
              <Flower2 size={22} strokeWidth={1.5} data-id="element-42" data-mp="3fftsherstox0" />
            </motion.div>

            <motion.div animate={{
            rotate: [0, 10, 0],
            x: [0, 5, 0]
          }} transition={{
            duration: 8,
            repeat: Infinity,
            ease: 'easeInOut'
          }} className="absolute bottom-1/2 -right-4 text-[#2D5A27] opacity-20" data-id="element-43" data-mp="3u47szj1qt1ae">
              <Leaf size={18} strokeWidth={1} data-id="element-44" data-mp="71l46iwb7kan" />
            </motion.div>
          </div>

          <motion.img initial={{
          y: 0
        }} animate={{
          y: [0, -12, 0]
        }} transition={{
          duration: 5,
          repeat: Infinity,
          ease: 'easeInOut'
        }} src={MAIN_IMAGE} alt="Cosmética Viva Libro" className="w-[85%] mx-auto relative z-10 hover:scale-[1.05] transition-all duration-500 drop-shadow-[0_25px_45px_rgba(183,110,121,0.25)] pt-[0px] pb-[0px] mt-[0px] mb-[0px]" data-id="element-45" data-mp="2xn9cke0ovne" />

          <div className="relative z-10 mt-2 flex flex-col items-center gap-1.5 text-center" data-id="element-46" data-mp="1rwskmfiv5mkn">
            <div className="flex items-center gap-1 text-[#D4AF37]" aria-label="Valoración de 4.9 sobre 5 estrellas" data-id="element-47" data-mp="1wvvlrovq38nc">
              <span className="text-[11px] font-black text-[#2D5A27] mr-1" data-id="element-48" data-mp="21m2b5qy26x6n">
                4.9/5
              </span>
              <span className="flex items-center gap-1" aria-hidden="true" data-id="element-49" data-mp="26knbrrh83ivm">
                {[...Array(5)].map((_, index) => <Star key={index} size={13} fill="currentColor" strokeWidth={1.5} className="premium-star-shine" style={{
                animationDelay: `${index * 160}ms`
              }} data-id="element-50" data-mp="18z817nyvbg7f" data-mpi={index} />)}
              </span>
            </div>
            <p className="max-w-[285px] font-bold uppercase tracking-[0.12em] text-[#9D4D60] text-[9px]" data-id="element-51" data-mp="1iy6zccm0btg6">
              +1000 ALUMNAS YA CONFIARON EN NOSOTROS PARA CREAR SU COSMÉTICA NATURAL DESDE CASA.
            </p>
          </div>
        </div>

        <div className="max-w-xl mx-auto mb-10 flex flex-col items-center gap-4" data-id="element-52" data-mp="2z9kshq5sd7m9">
          <p className="md:text-[12px] font-medium text-[#2D5A27] uppercase tracking-[0.35em] opacity-95 pt-[0px] pb-[0px] mt-[0px] mb-[0px] text-[12px]" data-id="element-53" data-mp="nnilol25z3d8">
            <span className="text-[#9D4D60] font-black" data-id="element-54" data-mp="iopgdfx16io5">DEJÁ DE COMPRAR.</span>{' '}
            <span className="text-[#D4AF37] font-black italic" data-id="element-55" data-mp="dvmm15kfj56w">EMPEZÁ A CREAR.</span>
          </p>
          <motion.button type="button" onClick={scrollToPurchase} initial={{
          opacity: 0,
          y: 8
        }} animate={{
          opacity: 1,
          y: [0, -3, 0]
        }} transition={{
          opacity: {
            duration: 0.35,
            ease: 'easeOut'
          },
          y: {
            duration: 3.2,
            repeat: Infinity,
            ease: 'easeInOut'
          }
        }} whileHover={{
          scale: 1.04
        }} whileTap={{
          scale: 0.97
        }} className="group inline-flex items-center gap-2 rounded-full border border-[#D4AF37]/40 bg-white/70 px-5 py-2.5 text-[10px] font-black uppercase tracking-[0.12em] text-[#9D4D60] shadow-[0_8px_20px_rgba(183,110,121,0.12)] transition-colors hover:bg-[#9D4D60] hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#D4AF37] focus-visible:ring-offset-2" data-id="element-56" data-mp="8xl44nyqpbx0">
            <Sparkles size={13} className="text-[#D4AF37] transition-colors group-hover:text-[#F8E5B0]" data-id="element-57" data-mp="22fydxumauoc1" />
            Quiero crear cosmética natural
            <ArrowRight size={13} className="transition-transform group-hover:translate-x-0.5" data-id="element-58" data-mp="1tgl2iwem7poo" />
          </motion.button>
        </div>
      </Section>

      {/* Section Separator */}
      <div className="flex items-center justify-center py-4 opacity-30 mt-[2px] mb-[2px] pt-[7px] pb-[7px]" data-id="element-59" data-mp="1ok4dlzzld7aj">
        <div className="h-px w-12 bg-[#D4AF37]" data-id="element-60" data-mp="1ejlooqt670lr" />
        <Flower2 size={16} className="mx-4 text-[#D4AF37]" data-id="element-61" data-mp="1ekvmdew426rv" />
        <div className="h-px w-12 bg-[#D4AF37]" data-id="element-62" data-mp="3dwg2l8jnnmo4" />
      </div>

      {/* Problem Section with Comparison Table */}
      <Section className="my-16" data-id="element-63" data-mp="38xd466y6kep4">
        <div className="text-center mb-10" data-id="element-64" data-mp="38y4t4yx9ve6f">
          <div className="relative inline-block overflow-hidden" data-id="element-65" data-mp="3hevjdv3rxidy">
            <p className="font-bold text-[#9D4D60] uppercase tracking-[0.2em] text-xs relative z-10 pt-[0px] pb-[0px] mt-[0px] mb-[0px]" data-id="element-66" data-mp="3hcj79ykp628t">
              Lo difícil nunca fue crear cosmética. Fue saber por dónde empezar.
            </p>
            <motion.div initial={{
            x: '-100%'
          }} animate={{
            x: '200%'
          }} transition={{
            repeat: Infinity,
            duration: 3,
            ease: 'linear',
            repeatDelay: 2
          }} className="absolute inset-0 w-1/2 h-full bg-gradient-to-r from-transparent via-white/40 to-transparent skew-x-[-20deg] z-20 pointer-events-none" data-id="element-67" data-mp="3v5qvdg9kkflr" />
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-6 max-w-3xl mx-auto" data-id="element-68" data-mp="3cgbxtvt3e8m4">
          {/* Cons Column */}
          <div className="border border-red-100 rounded-[2rem] p-8 space-y-6 relative overflow-hidden group bg-[#F8E5E5]" data-id="element-69" data-mp="mpfb7jq8xnmr">
            <div className="absolute top-0 right-0 p-4 opacity-5 group-hover:opacity-10 transition-opacity" data-id="element-70" data-mp="rngx0cf2411x">
              <X size={80} className="text-red-500" data-id="element-71" data-mp="238y9tw0x04v" />
            </div>
            <h4 className="font-serif text-xl text-red-700 font-bold flex items-center gap-2" data-id="element-72" data-mp="3t6xp1imrd7aa">
              Empezar sola
            </h4>
            <ul className="space-y-4 text-sm md:text-base text-red-900/70" data-id="element-73" data-mp="7097ues30l0q">
              <li className="flex items-start gap-3" data-id="element-74" data-mp="710v92bizcfx">
                <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-red-300 shrink-0" data-id="element-75" data-mp="3ff9fnn3w8wx0" />
                Comprás ingredientes que después no usás.
              </li>
              <li className="flex items-start gap-3" data-id="element-76" data-mp="3af4yduv5vy5q">
                <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-red-300 shrink-0" data-id="element-77" data-mp="3p6nj25yyugvf" />
                Probás recetas distintas y ninguna queda igual.
              </li>
              <li className="flex items-start gap-3" data-id="element-78" data-mp="2wp1db780qahv">
                <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-red-300 shrink-0" data-id="element-79" data-mp="2wnglhpd395np" />
                Sentís que crear cosmética es más complicado de lo que
                imaginabas.
              </li>
              <li className="flex items-start gap-3" data-id="element-80" data-mp="176cqe8ryfwny">
                <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-red-300 shrink-0" data-id="element-81" data-mp="1c07erpii8ztd" />
                Perdés tiempo y dinero probando al azar.
              </li>
            </ul>
          </div>

          {/* Pros Column */}
          <div className="bg-[#2D5A27]/5 border border-[#2D5A27]/10 rounded-[2rem] p-8 space-y-6 relative overflow-hidden group shadow-sm" data-id="element-82" data-mp="129m8dfwlaqzw">
            <div className="absolute top-0 right-0 p-4 opacity-5 group-hover:opacity-10 transition-opacity" data-id="element-83" data-mp="1uxruo73ako1u">
              <Leaf size={80} className="text-[#2D5A27]" data-id="element-84" data-mp="1gys4uw41m343" />
            </div>
            <h4 className="font-serif text-xl text-[#2D5A27] font-bold flex items-center gap-2" data-id="element-85" data-mp="1kzu6tkpcgt9r">
              <div className="w-8 h-8 rounded-full bg-[#2D5A27]/10 flex items-center justify-center" data-id="element-86" data-mp="1l1oqkvovqfc9">
                <CheckCircle2 size={16} className="text-[#2D5A27]" data-id="element-87" data-mp="9kp1e8xtwgmg" />
              </div>
              Con Cosmética Viva
            </h4>
            <ul className="space-y-4 text-sm md:text-base text-[#2D5A27]/80" data-id="element-88" data-mp="psv8olek8hyi">
              <li className="flex items-start gap-3" data-id="element-89" data-mp="l0lbckb48fm7">
                <Leaf size={14} className="mt-1 text-[#D4AF37] shrink-0" data-id="element-90" data-mp="kzsd67q82yfo" />
                Sabés exactamente qué hacer desde el primer día.
              </li>
              <li className="flex items-start gap-3" data-id="element-91" data-mp="b3p22cde7pgl">
                <Leaf size={14} className="mt-1 text-[#D4AF37] shrink-0" data-id="element-92" data-mp="b12s66314xv7" />
                Aprendés con un método pensado para principiantes.
              </li>
              <li className="flex items-start gap-3" data-id="element-93" data-mp="13sw9y1yqlrei">
                <Leaf size={14} className="mt-1 text-[#D4AF37] shrink-0" data-id="element-94" data-mp="ysi2al11sjh0" />
                Entendés para qué sirve cada ingrediente.
              </li>
              <li className="flex items-start gap-3" data-id="element-95" data-mp="uqd8nmalnmud">
                <Leaf size={14} className="mt-1 text-[#D4AF37] shrink-0" data-id="element-96" data-mp="3jih7imqpkefx" />
                Creás productos que realmente funcionan.
              </li>
              <li className="flex items-start gap-3" data-id="element-97" data-mp="3ffkjuhmb9s54">
                <Leaf size={14} className="mt-1 text-[#D4AF37] shrink-0" data-id="element-98" data-mp="1uzmohit996oe" />
                Ganás confianza para formular por tu cuenta.
              </li>
            </ul>
          </div>
        </div>
      </Section>

      {/* Solution Section */}
      <Section className="relative overflow-hidden" data-id="element-99" data-mp="23ygid1f7biy9">
        {/* Subtle Background Decoration */}
        <div className="absolute top-0 right-0 opacity-5 pointer-events-none -mr-20 -mt-20" data-id="element-100" data-mp="28rstq9uvdt92">
          <Flower2 size={300} className="text-[#B76E79]" data-id="element-101" data-mp="2dp2qkakl976x" />
        </div>

        <div className="text-center mb-16 relative z-10" data-id="element-102" data-mp="2inw422zvky73">
          <h3 className="text-3xl md:text-4xl font-serif font-bold text-[#2D5A27] mb-6 leading-tight pt-[14px] pb-[14px]" data-id="element-103" data-mp="2iqiau0exz9o9">
            No comprás solamente un ebook. <br className="hidden md:block" data-id="element-104" data-mp="2ro2ibr3ee27b" />
            <span className="bg-gradient-to-r from-[#B76E79] to-[#D4AF37] bg-clip-text text-transparent" data-id="element-105" data-mp="sc9g9g1r66nq">
              Aprendés una habilidad que te va a acompañar toda la vida.
            </span>
          </h3>
          <div className="w-24 h-[1px] bg-[#D4AF37]/30 mx-auto mb-6" data-id="element-106" data-mp="20lyrxbxxkxp5"></div>
        </div>

        <div className="grid md:grid-cols-2 gap-12 mb-16 relative z-10" data-id="element-107" data-mp="1vn5fznyaler3">
          <div className="bg-white/60 backdrop-blur-sm p-8 md:p-10 rounded-[2.5rem] shadow-xl shadow-pink-100/20 border border-pink-50 relative group" data-id="element-108" data-mp="1vp8e6v9lme6w">
            <div className="absolute -top-4 -left-4 bg-[#D4AF37] text-white p-3 rounded-2xl shadow-lg transform -rotate-12 group-hover:rotate-0 transition-transform duration-500" data-id="element-109" data-mp="24nkc7icsoe9d">
              <Sparkles size={24} data-id="element-110" data-mp="2em9isez8qcab" />
            </div>
            <h4 className="font-serif italic text-[#2D5A27] mb-8 text-2xl border-b border-[#2D5A27]/10 pb-4" data-id="element-111" data-mp="2elrfwzi2oztf">
              ¿Qué vas a aprender?
            </h4>
            <ul className="grid grid-cols-1 gap-4" data-id="element-112" data-mp="2obkpxw2kh6vk">
              {['Cremas faciales y corporales', 'Sérums naturales', 'Tónicos faciales', 'Exfoliantes', 'Mascarillas', 'Bálsamos labiales', 'Perfumes naturales', 'Desodorantes naturales', 'Aceites corporales', 'Fórmulas antiedad', 'Maquillaje Natural', 'Protectores Solares', 'Sérums y Máscara de Pestañas', 'Productos Capilares', 'Jabones', 'Velas', 'Macerados, Aceites y Oleatos'].map((item, i) => <li key={i} className="flex items-center gap-3 text-slate-700 group/item" data-id="element-113" data-mp="3lwmaoi108kdw" data-mpi={i}>
                  <div className="w-6 h-6 rounded-full bg-[#2D5A27]/5 flex items-center justify-center group-hover/item:bg-[#2D5A27]/10 transition-colors" data-id="element-114" data-mp="36zlgm7vccdc9">
                    <Leaf size={12} className="text-[#2D5A27]" data-id="element-115" data-mp="2y79tovzfr811" />
                  </div>
                  <span className="text-sm md:text-base font-medium tracking-wide" data-id="element-116" data-mp="32y9pfxwtjk1y">
                    {item}
                  </span>
                </li>)}
            </ul>
            <div className="mt-8 pt-6 border-t border-[#D4AF37]/10" data-id="element-117" data-mp="2o7iyst6yqr0f">
              <p className="text-[#D4AF37] font-bold tracking-widest uppercase text-xs flex items-center gap-2" data-id="element-118" data-mp="2t9i2k46m7pxw">
                <Sparkles size={14} data-id="element-119" data-mp="2f9qsgej7ytp6" /> Y mucho más por descubrir
              </p>
            </div>
          </div>

          <div className="flex flex-col justify-center space-y-8" data-id="element-120" data-mp="2jcn23fqs7fgz">
            <div className="space-y-6" data-id="element-121" data-mp="2zoqn1ybbng5j">
              {[{
              title: 'Sin experiencia previa',
              text: 'Aunque nunca hayas hecho una crema en tu vida.'
            }, {
              title: 'Paso a paso real',
              text: 'Aunque no tengas conocimientos de ingredientes o Formulación.'
            }, {
              title: 'Tu propio ritmo',
              text: 'Acceso de por vida para que aprendas cuando vos quieras.'
            }].map((item, i) => <div key={i} className="flex gap-5 items-start group" data-id="element-122" data-mp="2bzxkvk43wc2h" data-mpi={i}>
                  <div className="w-12 h-12 rounded-2xl bg-white shadow-md flex items-center justify-center shrink-0 group-hover:scale-110 transition-transform duration-300 border border-pink-50" data-id="element-123" data-mp="271dxrgds0u8j">
                    <Heart size={20} className="text-[#9D4D60]" data-id="element-124" data-mp="220gjvfzsumcu" />
                  </div>
                  <div data-id="element-125" data-mp="1x5azwmpyjhre">
                    <h5 className="font-bold text-[#2D5A27] text-lg mb-1" data-id="element-126" data-mp="1t1v3nrhsvjf8">
                      {item.title}
                    </h5>
                    <p className="text-slate-500 leading-relaxed text-sm md:text-base" data-id="element-127" data-mp="8ismyij5dlkm">
                      {item.text}
                    </p>
                  </div>
                </div>)}
            </div>
          </div>
        </div>

        <div className="max-w-md mx-auto relative z-10" data-id="element-128" data-mp="hi61vqq1j2cq">
          <Button showShine className="bg-gradient-to-r from-[#B76E79] to-[#9D4D60] text-white hover:shadow-[0_10px_30px_rgba(157,77,96,0.3)] py-6 text-xl tracking-widest uppercase" data-id="element-129" data-mp="miahlej4jt1w">
            QUIERO EMPEZAR HOY <ArrowRight className="ml-2" data-id="element-130" data-mp="3q0u0hqfwxmk1" />
          </Button>
          <p className="text-center mt-4 text-[10px] uppercase tracking-[0.2em] text-slate-400 font-bold" data-id="element-131" data-mp="3uzf1vt6wica2">
            Acceso inmediato tras la compra
          </p>
        </div>
      </Section>

      {/* Methodology Section */}
      <Section className="my-20 relative" data-id="element-132" data-mp="329g85khrhqz2">
        {/* Decorative Background Elements */}
        <div className="absolute top-1/2 left-0 -translate-y-1/2 -ml-12 opacity-10 pointer-events-none" data-id="element-133" data-mp="378srhv9fcfww">
          <Leaf size={200} className="text-[#2D5A27] -rotate-45" data-id="element-134" data-mp="2h0oukvj64gtt" />
        </div>

        <div className="max-w-3xl mx-auto text-center mb-12 relative z-10" data-id="element-135" data-mp="2lz9vyya5p6ju">
          <h3 className="text-3xl md:text-4xl font-serif font-bold text-[#2D5A27] mb-6" data-id="element-136" data-mp="27yz3xrx41lx3">
            No son solo <span className="italic text-[#9D4D60]" data-id="element-137" data-mp="2c0ka6uf531yb">recetas</span>
          </h3>
          
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 relative z-10" data-id="element-138" data-mp="1y9fjwixnvm0n">
          {[{
          title: 'Fundamentos Reales',
          text: 'Introducción a la cosmética natural y formulación consciente.'
        }, {
          title: 'Materia Prima',
          text: 'Ingredientes naturales y cómo utilizarlos correctamente.'
        }, {
          title: 'Seguridad Total',
          text: 'Conservación y seguridad de tus productos elaborados.'
        }, {
          title: 'Bienestar Holístico',
          text: 'Aromaterapia y perfumes naturales con intención.'
        }, {
          title: 'Recetario Maestro',
          text: 'Un completo recetario con decenas de fórmulas listas.'
        }].map((item, i) => <div key={i} className="group bg-white/40 backdrop-blur-sm p-6 rounded-3xl border border-pink-100/50 hover:border-[#D4AF37]/30 transition-all duration-500 hover:shadow-xl hover:shadow-pink-100/20 flex gap-4 items-start" data-id="element-139" data-mp="vp1bxb4fwzf7" data-mpi={i}>
              <div className="w-10 h-10 rounded-2xl bg-[#2D5A27]/5 flex items-center justify-center shrink-0 group-hover:bg-[#2D5A27] group-hover:text-white transition-colors duration-500" data-id="element-140" data-mp="15l4f8kb1343q">
                <Leaf size={18} data-id="element-141" data-mp="1emkrkxlelgal" />
              </div>
              <div data-id="element-142" data-mp="1tca2vln7n0ol">
                <h4 className="font-bold text-[#2D5A27] text-sm md:text-base mb-1 uppercase tracking-wider" data-id="element-143" data-mp="1tcjl2n20k3jq">
                  {item.title}
                </h4>
                <p className="text-slate-500 text-xs md:text-sm leading-relaxed" data-id="element-144" data-mp="1ofjfed92t2t5">
                  {item.text}
                </p>
              </div>
            </div>)}

          {/* Final Accent Card */}
          <div className="md:col-span-2 bg-gradient-to-r from-[#2D5A27] to-[#1a3a18] p-6 rounded-3xl text-white flex items-center justify-between group overflow-hidden relative" data-id="element-145" data-mp="1xc0utsoh3mup">
            <div className="absolute top-0 right-0 opacity-10 group-hover:scale-110 transition-transform duration-700" data-id="element-146" data-mp="zzscv8tqtduf">
              <Flower2 size={120} data-id="element-147" data-mp="18ru6oo9b3vvq" />
            </div>
            <div className="relative z-10" data-id="element-148" data-mp="18sngjy3kb1i3">
              <p className="font-serif italic text-lg md:text-xl" data-id="element-149" data-mp="1dqxe2fcree6v">
                "Aprendé a formular, no solo a mezclar."
              </p>
            </div>
            <Sparkles className="text-[#D4AF37] relative z-10 animate-pulse" data-id="element-150" data-mp="1iogqd9pwcgw6" />
          </div>
        </div>
      </Section>

      {/* Bonus Section - Auto-scrolling Ribbon */}
      <section id="bonos" className="py-24 bg-white overflow-hidden relative pt-[49px] pb-[49px]" data-id="element-151" data-mp="1rqzt7ttomtif">
        {/* Subtle background texture */}
        <div className="absolute inset-0 opacity-[0.03] pointer-events-none" data-id="element-152" data-mp="3pikjbofnxz0o">
          <div className="absolute top-0 left-0 transform -translate-x-1/2 -translate-y-1/2" data-id="element-153" data-mp="3til92587pwn1">
            <Flower2 size={400} className="text-[#B76E79]" data-id="element-154" data-mp="3lzbyi8nyzrwe" />
          </div>
        </div>

        <div className="text-center px-6 relative z-10 pt-[0px] pb-[0px] mt-[0px] mb-[0px]" data-id="element-155" data-mp="3h6sk59hgksqj">
          <span className="text-[10px] uppercase tracking-[0.5em] text-[#9D4D60] font-bold mb-4 block" data-id="element-156" data-mp="3c9sgf583022l">
            Regalos por tu Confianza
          </span>
          <h3 className="font-serif font-bold text-[#2D5A27] mb-8 uppercase tracking-tight" data-id="element-157" data-mp="8s1uj2kg9jpe">
            <div className="flex items-center justify-center gap-3 md:gap-4 mb-3" data-id="element-158" data-mp="8po10y5f4fjy">
              <span className="text-7xl md:text-8xl text-[#9D4D60] leading-none" data-id="element-159" data-mp="3qun54m7ymj9">11</span>
              <div className="flex flex-col items-start leading-none gap-1" data-id="element-160" data-mp="3vuwvfse6m1za">
                <span className="text-3xl md:text-5xl" data-id="element-161" data-mp="3qwvbz6cug0na">Bonos</span>
                <span className="text-2xl md:text-4xl italic text-[#D4AF37] font-light" data-id="element-162" data-mp="2khb4q2sobsbn">Exclusivos</span>
              </div>
            </div>
            <div className="text-xl md:text-3xl mt-4 opacity-90 flex items-center justify-center gap-2" data-id="element-163" data-mp="2fgwxuo2t6of7">
              <span className="text-[#D4AF37]" data-id="element-164" data-mp="788jzpamr58w">+</span> Lista de Proveedores
            </div>
          </h3>
          <div className="inline-flex items-center gap-3 bg-[#FDF2F2] px-6 py-2 rounded-full border border-pink-100" data-id="element-165" data-mp="c1tcx2xd9918">
            <Sparkles size={16} className="text-[#D4AF37] animate-pulse" data-id="element-166" data-mp="3ucoikdlz3mkv" />
            <p className="text-sm md:text-base text-[#9D4D60] font-bold uppercase tracking-widest" data-id="element-167" data-mp="2aypvwcaq5eq">
              Gratis solo por hoy
            </p>
            <Sparkles size={16} className="text-[#D4AF37] animate-pulse" data-id="element-168" data-mp="uzw7rycli06y" />
          </div>
        </div>

        <div className="max-w-2xl mx-auto px-6 space-y-12 relative z-10" data-id="element-169" data-mp="h04p3kb4vvmm">
          {BONUSES.map(bonus => <motion.div key={bonus.id} whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="group cursor-pointer" data-id="element-170" data-mp="ly6eemz5kr6j">
              <div className="relative bg-white rounded-[3rem] p-8 border border-pink-50 shadow-sm hover:shadow-2xl hover:shadow-pink-100/40 transition-all duration-500 flex flex-col md:flex-row items-center gap-8 pt-[14px] pb-[14px]" data-id="element-171" data-mp="31s6rqr4a0m0a">
                <div className="w-full md:w-1/2 aspect-[4/5] overflow-hidden rounded-[2.5rem] bg-[#FDF2F2]/50 flex items-center justify-center shrink-0" data-id="element-172" data-mp="2u72upbt46h3g">
                  <img src={bonus.img} alt={bonus.title} className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700" data-id="element-173" data-mp="383ztbzfh52uw" />
                </div>
                <div className="flex-1 text-center md:text-left" data-id="element-174" data-mp="2fholq4tga1ol">
                  <div className="flex items-center gap-2 mb-4 justify-center md:justify-start" data-id="element-175" data-mp="2ajdb3rvbzn5b">
                    <span className="bg-[#D4AF37] text-white text-[10px] font-black px-4 py-1.5 rounded-full uppercase tracking-[0.2em]" data-id="element-176" data-mp="2p89sifja2cil">
                      {(bonus as any).badge || `Bono #${bonus.id}`}
                    </span>
                  </div>
                  <h4 className="text-[#2D5A27] text-3xl font-serif font-bold mb-4" data-id="element-177" data-mp="1wokoyakxr8pr">
                    {bonus.title}
                  </h4>
                  <p className="text-slate-500 text-sm mb-6 leading-relaxed" data-id="element-178" data-mp="3rt0tx8ib0na0">
                    {bonus.description}
                  </p>
                  <div className="flex flex-col md:items-start gap-1 bg-[#FDF2F2] p-5 rounded-2xl border border-pink-50 pt-[0px] pb-[0px] mt-[0px] mb-[0px] items-center justify-center" data-id="element-179" data-mp="loasnxv1zrg">
                    <span className="text-[11px] text-slate-400 line-through font-medium" data-id="element-180" data-mp="9fkrvoc64m00">
                      VALOR REAL: $15.000 ARS
                    </span>
                    <span className="font-black text-[#9D4D60] tracking-widest uppercase text-[12px]" data-id="element-181" data-mp="3dtj1mj5survw">
                      ¡Hoy es tuyo GRATIS!
                    </span>
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </section>

      {/* Alumni Photo Ribbon Section */}
      

      {/* Final Convincer Section */}
      <div className="relative py-24 px-6 overflow-hidden pt-[0px] pb-[0px] mt-[0px] mb-[0px] space-y-[0px]" data-id="element-182" data-mp="124i0ezqkv4fk">
        {/* Premium Background Elements */}
        <div className="absolute inset-0 bg-gradient-to-b from-white via-[#FDF2F2] to-[#FAC7C7]/30 pointer-events-none" data-id="element-183" data-mp="1c86sh4gpbs3n" />

        <div className="max-w-4xl mx-auto relative z-10" data-id="element-184" data-mp="17bya7i77jis9">
          <div className="bg-white/40 backdrop-blur-md rounded-[3rem] p-12 md:p-20 border border-white/60 shadow-[0_32px_64px_-12px_rgba(183,110,121,0.15)] text-center relative overflow-hidden group pt-[19px] pb-[19px] mt-[0px] mb-[0px] space-y-[0px]" data-id="element-185" data-mp="12hklfyn1w9wk">
            {/* Subtle Animated Shine */}
            <motion.div initial={{
            x: '-100%'
          }} animate={{
            x: '200%'
          }} transition={{
            repeat: Infinity,
            duration: 4,
            ease: 'linear',
            repeatDelay: 3
          }} className="absolute inset-0 w-1/2 h-full bg-gradient-to-r from-transparent via-white/30 to-transparent skew-x-[-25deg] pointer-events-none" data-id="element-186" data-mp="oi2vvh1xksm5" />

            {/* Decorative Icons */}
            <div className="absolute top-8 left-8 text-[#D4AF37]/20" data-id="element-187" data-mp="29ucjyio32ili"></div>
            <div className="absolute bottom-8 right-8 text-[#B76E79]/20" data-id="element-188" data-mp="2t5qljk9ef9j8"></div>

            <div className="max-w-2xl mx-auto space-y-10" data-id="element-189" data-mp="2x5qyf0gunco6">
              <div className="space-y-4" data-id="element-190" data-mp="2jff5x0gcrbwi">
                <span className="text-[10px] md:text-xs font-black uppercase tracking-[0.4em] text-[#D4AF37]" data-id="element-191" data-mp="2jechr0aeznka">
                  HOY EMPIEZA ALGO NUEVO
                </span>
                <h3 className="md:text-5xl font-serif font-bold text-[#2D5A27] text-[28px] leading-tight" data-id="element-192" data-mp="29gpyk1m319ui">
                  Tu próxima crema, tu próximo sérum o tu próximo
                  emprendimiento... <br data-id="element-193" data-mp="20gt4fkgxbis2" />
                  <span className="italic text-[#9D4D60] relative inline-block mt-2" data-id="element-194" data-mp="20hl00vaitgic">
                    Puede empezar con una sola decisión.
                    <motion.div initial={{
                    width: 0
                  }} whileInView={{
                    width: '100%'
                  }} transition={{
                    duration: 1,
                    delay: 0.5
                  }} className="absolute -bottom-2 left-0 h-[2px] bg-[#D4AF37]/30" data-id="element-195" data-mp="25hql1smac4rg" />
                  </span>
                </h3>
              </div>

              <div className="space-y-6" data-id="element-196" data-mp="8uy24qitd2xd">
                <p className="md:text-2xl text-slate-600 font-medium text-[14px] leading-relaxed" data-id="element-197" data-mp="ml1ix1yxc4ff">
                  Más de{' '}
                  <span className="text-[#2D5A27] font-bold" data-id="element-198" data-mp="hszy2rnox5ds">
                    1.000 personas
                  </span>{' '}
                  ya dieron el primer paso. <br className="hidden md:block" data-id="element-199" data-mp="rjl593hfji8b" />
                  Ahora es tu momento de empezar a{' '}
                  <span className="text-[#2D5A27] font-bold" data-id="element-200" data-mp="15j404ul8cx2o">
                    crear con confianza
                  </span>
                  .
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Purchase Section */}
      <div ref={purchaseSectionRef} className="py-24 px-6 relative overflow-hidden space-y-[33px] bg-[#FAC7C7] pt-[0px] pb-[0px] mt-[0px] mb-[0px]" data-id="element-201" data-mp="37ctndxwvbhcb">
        {/* Decorative Background Elements */}
        <div className="absolute top-0 left-0 w-full h-full pointer-events-none overflow-hidden" data-id="element-202" data-mp="1ikaolsmu67ut">
          <motion.div animate={{
          rotate: 360
        }} transition={{
          duration: 50,
          repeat: Infinity,
          ease: 'linear'
        }} className="absolute -top-24 -left-24 text-[#B76E79]/10" data-id="element-203" data-mp="1dl7uh38e9m1m">
            <Flower2 size={400} data-id="element-204" data-mp="21gsm6qod91yz" />
          </motion.div>
          <motion.div animate={{
          y: [0, 20, 0]
        }} transition={{
          duration: 8,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="absolute bottom-12 -right-12 text-[#2D5A27]/10" data-id="element-205" data-mp="21f7rn121xj14">
            <Leaf size={300} data-id="element-206" data-mp="267sh5qdxd9yu" />
          </motion.div>
        </div>

        <div className="max-w-3xl mx-auto relative z-10" data-id="element-207" data-mp="268kep6r31hrr">
          {/* Offer Selection Section */}
          <div className="mb-12 space-y-6" data-id="element-208" data-mp="2k7thn4qa2fds">
            <div className="text-center space-y-1" data-id="element-209" data-mp="2f8z2qdvflayy">
              <p className="text-[10px] md:text-xs font-black uppercase tracking-[0.3em] text-[#2D5A27] bg-white/50 backdrop-blur-sm py-1 px-3 rounded-full w-fit mx-auto border border-[#D4AF37]/20 shadow-sm" data-id="element-210" data-mp="2faa4k85bg8nf">
                ✨ Elegí la alternativa que mejor se adapte a vos
              </p>
              <h3 className="text-xl md:text-2xl font-serif font-bold text-[#2D5A27] uppercase tracking-tight" data-id="element-211" data-mp="2pt11tqey4uwj">
                Comenzá a crear desde hoy
              </h3>
            </div>

            <div className="grid gap-4" data-id="element-212" data-mp="2g2zhn9pprwmw">
              {/* Option 1: Base Offer */}
              <motion.div whileHover={{
              scale: 1.01
            }} whileTap={{
              scale: 0.99
            }} onClick={() => setSelectedOffer('base')} className={cn('relative cursor-pointer p-6 rounded-[2.5rem] border-2 transition-all duration-300', selectedOffer === 'base' ? 'bg-white border-[#A78BFA] shadow-xl shadow-purple-100/50' : 'bg-white/60 border-transparent hover:border-purple-200')} data-id="element-213" data-mp="2kvj2mrqqdu1q">
                <div className="flex items-start gap-4" data-id="element-214" data-mp="223gg4zrerjjk">
                  <div className={cn('mt-1 w-6 h-6 rounded-full border-2 flex items-center justify-center shrink-0 transition-colors', selectedOffer === 'base' ? 'border-[#A78BFA] bg-[#A78BFA]' : 'border-slate-300')} data-id="element-215" data-mp="7ob0sux4456r">
                    {selectedOffer === 'base' && <div className="w-2 h-2 rounded-full bg-white" data-id="element-216" data-mp="3u3m1tcxpi7rd" />}
                  </div>
                  <div className="flex-1 space-y-3" data-id="element-217" data-mp="3q3lojvmcg2lw">
                    <div className="flex flex-wrap items-baseline justify-between gap-2" data-id="element-218" data-mp="qn5iocrvhlr5">
                      <h4 className="font-serif font-bold text-[#2D5A27] text-lg md:text-xl" data-id="element-219" data-mp="lnsof6yo9cej">
                        Cosmética Viva + 11 Bonos + Proveedores
                      </h4>
                      <div className="text-right" data-id="element-220" data-mp="cmupv4705x3c">
                        <p className="text-xs line-through text-slate-400" data-id="element-221" data-mp="cm2v1vl8c3e4">
                          $59.990
                        </p>
                        <p className="text-xl font-bold text-[#2D5A27]" data-id="element-222" data-mp="329tsytjczoia">
                          $19.990
                        </p>
                      </div>
                    </div>
                    <p className="text-xs md:text-sm text-slate-500 leading-relaxed font-medium" data-id="element-223" data-mp="1csy8ey6vl8qk">
                      Explorá el mundo de la cosmética natural creando tus
                      propios sérums, cremas, skincare, maquillaje, protectores
                      solares y productos capilares. Una guía completa para
                      aprender desde casa, paso a paso y a tu ritmo.
                    </p>
                    <div className="flex flex-wrap gap-x-4 gap-y-1 pt-2 border-t border-slate-100" data-id="element-224" data-mp="20kn3unezudbq">
                      {['✓ Guía Cosmética Viva', '✓ 11 Bonos Exclusivos', '✓ Lista de Proveedores', '✓ Acceso inmediato', '✓ Formato PDF'].map((item, i) => <span key={i} className="text-[10px] font-bold text-[#9D4D60] uppercase tracking-wider" data-id="element-225" data-mp="29ka6tdndfr6w" data-mpi={i}>
                          {item}
                        </span>)}
                    </div>
                  </div>
                </div>
              </motion.div>

              {/* Option 2: Premium Offer */}
              <motion.div whileHover={{
              scale: 1.01
            }} whileTap={{
              scale: 0.99
            }} onClick={() => setSelectedOffer('premium')} className={cn('relative cursor-pointer p-6 rounded-[2.5rem] border-2 transition-all duration-300', selectedOffer === 'premium' ? 'bg-white border-[#A78BFA] shadow-2xl shadow-purple-200/50' : 'bg-white/60 border-transparent hover:border-purple-200')} data-id="element-226" data-mp="3g0x681f7amf4">
                {/* Badge */}
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-gradient-to-r from-[#D4AF37] to-[#B76E79] text-white text-[10px] font-black px-4 py-1 rounded-full shadow-lg z-20 whitespace-nowrap tracking-widest" data-id="element-227" data-mp="2sdfluqy9mqm6">
                  ⭐ MÁS ELEGIDO
                </div>

                <div className="flex items-start gap-4" data-id="element-228" data-mp="2elixmxzpx0v2">
                  <div className={cn('mt-1 w-6 h-6 rounded-full border-2 flex items-center justify-center shrink-0 transition-colors', selectedOffer === 'premium' ? 'border-[#A78BFA] bg-[#A78BFA]' : 'border-slate-300')} data-id="element-229" data-mp="2ejy4nct1xpzb">
                    {selectedOffer === 'premium' && <div className="w-2 h-2 rounded-full bg-white" data-id="element-230" data-mp="tvnasa46h76w" />}
                  </div>
                  <div className="flex-1 space-y-3" data-id="element-231" data-mp="g3z1eelbcwtm">
                    <div className="flex flex-wrap items-baseline justify-between gap-2" data-id="element-232" data-mp="g5jv61zt0bqf">
                      <h4 className="font-serif font-bold text-[#2D5A27] text-lg md:text-xl" data-id="element-233" data-mp="k5tz7941cs2n">
                        Pack Completo Cosmética Viva + Esencia Áurica
                      </h4>
                      <div className="text-right" data-id="element-234" data-mp="1csojo60urrg4">
                        <p className="text-xs line-through text-slate-400" data-id="element-235" data-mp="yu6yaeyf6r1d">
                          $99.990
                        </p>
                        <p className="text-xl font-bold text-[#2D5A27]" data-id="element-236" data-mp="13s8jb5fep0fh">
                          $29.990
                        </p>
                      </div>
                    </div>
                    <p className="text-xs md:text-sm leading-relaxed font-medium text-[#64748B]" data-id="element-237" data-mp="3ojsfkms69w7i">
                      Accedé al universo completo de la creación natural.
                      Aprendé a elaborar skincare, cremas, pomadas, protector
                      solar, maquillaje y productos capilares con Cosmética
                      Viva, y además llevate Esencia Áurica una guía para crear
                      perfumes naturales, Agua Florida, brumas áuricas desde
                      casa. Hoy te llevas 2 formaciones premium, 17 bonos
                      exclusivos y la lista de proveedores.
                    </p>
                    <div className="flex flex-wrap gap-x-4 gap-y-1 pt-2 border-t border-slate-100" data-id="element-238" data-mp="16cekx6gjsesv">
                      {['✓ Cosmética Viva', '✓ Esencia Áurica', '✓ 17 Bonos Exclusivos', '✓ Lista de Proveedores', '✓ Acceso inmediato', '✓ Formato PDF'].map((item, i) => <span key={i} className="text-[10px] font-bold text-[#9D4D60] uppercase tracking-wider" data-id="element-239" data-mp="2vt5v4dwj8u66" data-mpi={i}>
                          {item}
                        </span>)}
                    </div>
                  </div>
                </div>
              </motion.div>
            </div>

            <p className="text-center text-sm font-bold text-[#9D4D60] animate-pulse" data-id="element-240" data-mp="ii4dvo43c1c6">
              💜 Ahorrás más de $70.000 comprando el pack completo.
            </p>
          </div>

          {/* Pricing */}
          <div className="text-center space-y-8 mb-12" data-id="element-241" data-mp="raxy7zye9qww">
            <div className="space-y-2" data-id="element-242" data-mp="rcitxswg3fwc">
              <p className="text-xl md:text-2xl line-through text-slate-400 font-serif italic" data-id="element-243" data-mp="3qql739jpkwmp">
                Antes {selectedOffer === 'premium' ? '$99.990' : '$59.990'} ARS
              </p>
              <div className="relative inline-block" data-id="element-244" data-mp="3klu7069sebl">
                <p className="text-7xl md:text-9xl font-serif font-bold tracking-tighter text-[#2D5A27] drop-shadow-sm" data-id="element-245" data-mp="3n80yxlc6psr">
                  {selectedOffer === 'premium' ? '$29.990' : '$19.990'}
                  <span className="text-3xl md:text-4xl ml-2" data-id="element-246" data-mp="1f00n9svcym1f">ARS</span>
                </p>
                <div className="absolute -top-4 -right-8 bg-[#D4AF37] text-white text-[10px] font-black px-3 py-1 rounded-full shadow-lg transform rotate-12 uppercase tracking-widest" data-id="element-247" data-mp="1jxipl0eve30g">
                  {selectedOffer === 'premium' ? '70% OFF' : '66% OFF'}
                </div>
              </div>
              <p className="text-xl md:text-2xl text-[#9D4D60] font-serif font-bold italic tracking-wide" data-id="element-248" data-mp="14gogt5lufok4">
                Pago único • Acceso de por vida
              </p>
            </div>

            {/* CTA Button */}
            <div className="relative group mb-6 max-w-xl mx-auto" data-id="element-249" data-mp="1ef45l1xeelqg">
              <div className="absolute -inset-1.5 bg-gradient-to-r from-[#B76E79] via-[#D4AF37] to-[#9D4D60] rounded-full blur-md opacity-30 group-hover:opacity-60 transition duration-1000 group-hover:duration-200" data-id="element-250" data-mp="19dokxaz4uh8l"></div>
              <Button showShine onClick={() => {
              const url = selectedOffer === 'premium' ? 'https://novalibros.shop/cart/48530262917369:1' : 'https://novalibros.shop/cart/48530262130937:1';
              window.location.href = url;
            }} className="relative bg-gradient-to-r from-[#B76E79] via-[#9D4D60] to-[#B76E79] bg-[length:200%_auto] hover:bg-right transition-all duration-500 text-white text-xl md:text-2xl py-8 rounded-full border-2 border-white/30 shadow-[0_15px_40px_rgba(157,77,96,0.4)] tracking-[0.1em] overflow-hidden" data-id="element-251" data-mp="1ja9pxwb5jscf">
                <Sparkles className="w-5 h-5 md:w-6 md:h-6 animate-pulse text-white/80" data-id="element-252" data-mp="36826r64trio3" />
                <span className="px-2" data-id="element-253" data-mp="2rbjudhkzmsne">
                  {selectedOffer === 'premium' ? 'SÍ, QUIERO EL PACK COMPLETO' : 'SÍ, QUIERO MI GUIA AHORA'}
                </span>
                <ArrowRight className="w-6 h-6 md:w-8 md:h-8 group-hover:translate-x-1 transition-transform" data-id="element-254" data-mp="2ib4wliqu7l30" />
              </Button>
            </div>

            <div className="inline-flex items-center gap-2.5 bg-white/40 backdrop-blur-md px-5 py-2.5 rounded-xl border border-[#D4AF37]/10 shadow-[0_4px_20px_-4px_rgba(212,175,55,0.1)] mt-[0px] mb-[12px] ml-[6px] mr-[6px] group hover:border-[#D4AF37]/30 transition-all duration-500 scale-[0.92] pt-[8px] pb-[8px]" data-id="element-255" data-mp="2nb10lhzjbcik">
              <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-[#2D5A27]/10 to-[#2D5A27]/5 flex items-center justify-center text-[#2D5A27] shadow-inner group-hover:scale-105 transition-transform" data-id="element-256" data-mp="1ncc3wrhvc2uz">
                <CreditCard size={16} strokeWidth={1.5} data-id="element-257" data-mp="1x6lwoaaq3368" />
              </div>
              <div className="flex flex-col items-start leading-none" data-id="element-258" data-mp="220yj8t7hwum7">
                <span className="font-bold text-[#2D5A27] text-sm tracking-tight" data-id="element-259" data-mp="261s7jnouobfm">
                  Hasta 3 cuotas sin interés
                </span>
              </div>
            </div>

            {/* Unified Urgency & Counter Block */}
            <div className="max-w-sm mx-auto space-y-2 mt-6 mb-6" data-id="element-260" data-mp="2fzy6bwfd11g9">
              {/* Viewers & Coupons */}
              <div className="flex flex-row items-center justify-center gap-8 py-2 px-6 bg-white/40 backdrop-blur-sm rounded-t-2xl border border-[#D4AF37]/10 pt-[4px] pb-[4px]" data-id="element-261" data-mp="2kw6svuvvzwxg">
                <div className="flex items-center gap-3" data-id="element-262" data-mp="qks1zar53rg4">
                  <div className="relative flex h-2 w-2" data-id="element-263" data-mp="33v1m2lac6ehq">
                    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75" data-id="element-264" data-mp="33wmfg7kwzre0"></span>
                    <span className="relative inline-flex rounded-full h-2 w-2 bg-green-500" data-id="element-265" data-mp="2v1yakij94bpq"></span>
                  </div>
                  <p className="text-[9px] md:text-[10px] font-black text-[#2D5A27] uppercase tracking-widest" data-id="element-266" data-mp="2q3wkhdnerc4r">
                    {viewers} MIRANDO
                  </p>
                </div>
                <div className="w-px h-4 bg-[#D4AF37]/20" data-id="element-267" data-mp="3irivh6yytj1n" />
                <div className="flex items-center gap-3" data-id="element-268" data-mp="3ipy1pjkh644u">
                  <Ticket size={12} className="text-red-500" data-id="element-269" data-mp="3dredfciesg9b" />
                  <p className="text-[9px] md:text-[10px] font-black text-red-600 uppercase tracking-widest" data-id="element-270" data-mp="38tuy099z5xfs">
                    {coupons} CUPOS
                  </p>
                </div>
              </div>

              {/* Student Counter */}
              <div className="bg-white/40 backdrop-blur-sm rounded-b-2xl p-3 text-center border border-[#D4AF37]/10 border-t-0 shadow-inner pt-[8px] pb-[8px]" data-id="element-271" data-mp="1xcuzgvx1amdb">
                <div className="flex items-center justify-center gap-2 mb-0.5" data-id="element-272" data-mp="23v7ugx934odq">
                  <Users size={14} className="text-[#D4AF37]" data-id="element-273" data-mp="1pux0vmge4vov" />
                  <p className="text-2xl font-serif font-bold text-[#2D5A27]" data-id="element-274" data-mp="1pundm6mqd2mv">
                    {studentCount.toLocaleString('de-DE')}
                  </p>
                </div>
                <p className="text-[8px] font-black uppercase tracking-[0.2em] text-[#9D4D60]" data-id="element-275" data-mp="1g4bxzmtop505">
                  ALUMNAS YA ADQUIRIERON SU GUÍA
                </p>
              </div>
            </div>
          </div>

          {/* Countdown Timer Bar */}
          <div className="max-w-md mx-auto mb-6 px-2" data-id="element-276" data-mp="1b5r5yaol5rms">
            <div className="flex items-center justify-between mb-2" data-id="element-277" data-mp="1b6k7mx8otqy2">
              <span className="text-[10px] font-black uppercase tracking-[0.2em] text-[#9D4D60]" data-id="element-278" data-mp="x7aoppt3kiqe">
                La oferta termina en:
              </span>
              <CountdownText data-id="element-279" data-mp="1276wm04x0ub8" />
            </div>
            <div className="h-2 w-full bg-white/40 rounded-full overflow-hidden border border-pink-100 shadow-inner" data-id="element-280" data-mp="iklpzq6o69l2">
              <motion.div initial={{
              width: '100%'
            }} animate={{
              width: '0%'
            }} transition={{
              duration: 600,
              ease: 'linear'
            }} className="h-full bg-gradient-to-r from-[#B76E79] to-[#9D4D60]" data-id="element-281" data-mp="dm0qxu35lvy7" />
            </div>
          </div>

          {/* MercadoLíder Trust Section */}
          <div className="bg-white/80 backdrop-blur-sm border border-slate-100 rounded-2xl p-5 mb-10 shadow-sm max-w-md mx-auto text-left" data-id="element-282" data-mp="wk3kmm6nch2c">
            <div className="flex items-center gap-3 mb-4" data-id="element-283" data-mp="1b7g8winu90wf">
              <div className="w-10 h-10 rounded-full bg-green-50 flex items-center justify-center text-green-600 shrink-0" data-id="element-284" data-mp="168v9glgeul91">
                <Medal size={20} data-id="element-285" data-mp="1k9frhfei4d1h" />
              </div>
              <div data-id="element-286" data-mp="1g7kswinygdre">
                <h4 className="text-green-600 font-bold text-sm leading-tight" data-id="element-287" data-mp="1g840b5fzbjr6">
                  MercadoLíder Platinum
                </h4>
                <p className="text-slate-400 text-[10px] font-medium" data-id="element-288" data-mp="39pruvw95s8g8">
                  ¡Es uno de los mejores del sitio!
                </p>
              </div>
            </div>

            <div className="grid grid-cols-5 gap-1 mb-5" data-id="element-289" data-mp="3jgd042jc8b84">
              <div className="h-1 rounded-full bg-[#FFF1F1]" data-id="element-290" data-mp="3offu8rxs4x1b" />
              <div className="h-1 rounded-full bg-[#FFF1F1]" data-id="element-291" data-mp="3oh0nme8cy9xl" />
              <div className="h-1 rounded-full bg-[#FFF1F1]" data-id="element-292" data-mp="2qs7bh4p5y230" />
              <div className="h-1 rounded-full bg-green-200" data-id="element-293" data-mp="2vq0ifzyaj04c" />
              <div className="h-1 rounded-full bg-green-500" data-id="element-294" data-mp="2vqinnm2xkooe" />
            </div>

            <div className="mb-5" data-id="element-295" data-mp="30ok3ly5287vn">
              <p className="text-xl font-bold text-slate-800" data-id="element-296" data-mp="30rpunix91ju0">1010</p>
              <p className="text-[10px] text-slate-400 font-medium" data-id="element-297" data-mp="34si5uhpolysx">
                Ventas en los últimos 60 días
              </p>
            </div>

            <div className="space-y-2.5 pt-4 border-t border-slate-50" data-id="element-298" data-mp="k0g4de89zegu">
              <div className="flex items-center gap-3" data-id="element-299" data-mp="k2keidwrp9pk">
                <MessageCircle size={14} className="text-green-500" data-id="element-300" data-mp="24hgu4uxv4ki8" />
                <p className="text-[11px] font-medium text-slate-600" data-id="element-301" data-mp="20gn6m2oc17pv">
                  Brinda buena atención
                </p>
              </div>
              <div className="flex items-center gap-3" data-id="element-302" data-mp="1volz0u240566">
                <Zap size={14} className="text-green-500" data-id="element-303" data-mp="1qs5avzuwtqt3" />
                <p className="text-[11px] font-medium text-slate-600" data-id="element-304" data-mp="1qpj3q1bxldbe">
                  Despacha sus productos a tiempo
                </p>
              </div>
              <div className="flex items-center gap-3" data-id="element-305" data-mp="1gsefzx2ft9sh">
                <ShieldCheck size={14} className="text-[#D4AF37]" data-id="element-306" data-mp="1crazr9gh9bqq" />
                <p className="text-[11px] font-bold text-slate-800" data-id="element-307" data-mp="1crug4lqhbs2n">
                  Compra 100% Segura
                </p>
              </div>
            </div>
          </div>

          {/* Trust Badges */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center justify-items-center mb-10 opacity-90" data-id="element-308" data-mp="373ixsvo3i8qq">
            <img src="https://cdn.magicpatterns.com/uploads/2esg8TZ8XPcPzVZ7uhJqsN/pasted-image.png" alt="Compra Segura" className="h-14 md:h-16 object-contain" data-id="element-309" data-mp="3lb5g0llkgwvq" />
            <img src="https://cdn.magicpatterns.com/uploads/wokS51Pt6mAkbEbb1iBzyx/pasted-image.png" alt="Pago Seguro Garantizado" className="h-14 md:h-16 object-contain" data-id="element-310" data-mp="3q35cg42fh7nk" />
          </div>
        </div>
      </div>

      {/* Testimonials & Comments */}
      <Section className="bg-white rounded-t-[3rem] -mt-12 relative z-10" data-id="element-311" data-mp="8t7chqvaln10">
        <div className="text-center mb-12" data-id="element-312" data-mp="cvc1udepjxhu">
          <h3 className="text-3xl font-serif font-bold text-[#2D5A27] mb-2" data-id="element-313" data-mp="cuaqs8xozb04">
            Lo que dicen nuestras alumnas
          </h3>
          <div className="flex justify-center gap-1 text-[#D4AF37]" data-id="element-314" data-mp="3v31is9yllb6a">
            {[...Array(5)].map((_, i) => <Star key={i} fill="currentColor" data-id="element-315" data-mp="3wqocwo3f8nx" data-mpi={i} />)}
          </div>
        </div>

        {/* Comment Input */}
        <div className="bg-[#FDF2F2] p-8 rounded-3xl mb-12 border border-pink-100" data-id="element-316" data-mp="2jo4s6vmrmdwt">
          <h4 className="font-bold mb-4 text-lg" data-id="element-317" data-mp="2om66l398xp1y">Dejá tu reseña</h4>
          <div className="flex gap-2 mb-4" data-id="element-318" data-mp="2h0av3pwmc322">
            {[1, 2, 3, 4, 5].map(star => <button key={star} onClick={() => setNewRating(star)} data-id="element-319" data-mp="2c2sgpjzu0vmo">
                <Star className={`w-6 h-6 ${star <= newRating ? 'text-[#D4AF37] fill-[#D4AF37]' : 'text-slate-300'}`} data-id="element-320" data-mp="2c4lox3q3fnws" />
              </button>)}
          </div>
          <textarea value={newComment} onChange={e => setNewComment(e.target.value)} placeholder="Escribí tu experiencia aquí..." className="w-full p-4 rounded-xl border border-slate-200 focus:ring-2 focus:ring-[#2D5A27] focus:border-transparent outline-none min-h-[120px] mb-4" data-id="element-321" data-mp="2l48snw6ap5t0" />
          <button onClick={handlePostComment} className="bg-[#2D5A27] text-white px-8 py-3 rounded-xl font-bold hover:bg-[#1a3a18] transition-colors" data-id="element-322" data-mp="273fvf3olzwm7">
            Publicar
          </button>
        </div>

        {/* Comments List */}
        <div className="space-y-6" data-id="element-323" data-mp="1elah3etwie7a">
          {comments.slice(0, visibleComments).map(comment => <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} key={comment.id} className="bg-white p-6 rounded-2xl border border-slate-100 shadow-sm" data-id="element-324" data-mp="19n0lj349lbl5">
              <div className="flex items-center gap-4 mb-4" data-id="element-325" data-mp="t5de7ldg1q3o">
                {comment.avatar ? <img src={comment.avatar} alt={comment.name} className="w-12 h-12 rounded-full object-cover border-2 border-[#2D5A27]/10" data-id="element-326" data-mp="y1bvyq49o9v4" /> : <div className="w-12 h-12 rounded-full bg-[#2D5A27]/10 flex items-center justify-center text-[#2D5A27] font-bold text-xl" data-id="element-327" data-mp="180t196flwlqk">
                    {comment.name[0]}
                  </div>}
                <div data-id="element-328" data-mp="1gt4q4nv2o14f">
                  <div className="flex items-center gap-2" data-id="element-329" data-mp="1gsmo1alqasol">
                    <p className="font-bold" data-id="element-330" data-mp="1gv7nxu2guyjp">{comment.name}</p>
                    <span className="text-xs text-slate-400" data-id="element-331" data-mp="1lqwifizmpp95">
                      • {comment.date}
                    </span>
                  </div>
                  <div className="flex gap-0.5" data-id="element-332" data-mp="1vqf0ftvzb0yk">
                    {[...Array(5)].map((_, i) => <Star key={i} className={`w-3 h-3 ${i < comment.rating ? 'text-[#D4AF37] fill-[#D4AF37]' : 'text-slate-200'}`} data-id="element-333" data-mp="1voayviljye1g" data-mpi={i} />)}
                  </div>
                </div>
              </div>
              <p className="text-slate-600 leading-relaxed mb-4" data-id="element-334" data-mp="3bbfxogtamxh6">
                {comment.text}
              </p>
              {(comment as any).image && <div className="mb-4 rounded-xl overflow-hidden border border-slate-100" data-id="element-335" data-mp="31boyi1tsfuar">
                  <img src={(comment as any).image} alt="Creación de alumna" className="w-full h-auto object-cover max-h-[300px]" data-id="element-336" data-mp="2t9x9j9n91kf" />
                </div>}
              <button className="flex items-center gap-2 text-sm font-medium text-slate-400 hover:text-[#2D5A27] transition-colors" data-id="element-337" data-mp="3u0mhy89qjx53">
                <ThumbsUp className="w-4 h-4" data-id="element-338" data-mp="3ka1advc33ia1" /> {comment.likes}
              </button>
            </motion.div>)}
        </div>

        {visibleComments < 30 && <div className="text-center mt-12" data-id="element-339" data-mp="lkt1ftfemlo1">
            <button onClick={() => setVisibleComments(prev => Math.min(prev + 5, 35))} className="text-[#2D5A27] font-bold border-2 border-[#2D5A27] px-8 py-3 rounded-xl hover:bg-[#2D5A27] hover:text-white transition-all" data-id="element-340" data-mp="gtb2fawxyv5p">
              Cargar 5 comentarios más
            </button>
          </div>}
      </Section>

      {/* Footer */}
      <footer className="text-white py-12 px-6 text-center bg-[#4D384D] pt-[41px] pb-[41px] mt-[47px] mb-[47px]" data-id="element-341" data-mp="1yei4diki0pmn">
        <p className="text-sm opacity-50 mb-4" data-id="element-342" data-mp="1tfozgeja26y3">
          © 2026 Cosmética Viva - Todos los derechos reservados
        </p>
        <p className="text-xs opacity-30 max-w-xl mx-auto" data-id="element-343" data-mp="2q6qyifsu95w2">
          Este producto no sustituye el asesoramiento profesional. Siempre
          consulte a su médico o dermatólogo antes de aplicar nuevos productos
          en su piel.
        </p>
      </footer>

      {/* Sticky Bar */}
      <AnimatePresence data-id="element-344" data-mp="2ccznt43dffyr">
        {showSticky && <motion.div initial={{
        y: -100,
        x: '-50%',
        opacity: 0
      }} animate={{
        y: 0,
        x: '-50%',
        opacity: 1
      }} exit={{
        y: -100,
        x: '-50%',
        opacity: 0
      }} className="fixed top-6 left-1/2 z-[90] w-[90%] max-w-md" data-id="element-345" data-mp="39sdjirbekydv">
            <div className="bg-white/60 backdrop-blur-xl border border-white/40 shadow-[0_8px_32px_rgba(157,77,96,0.15)] rounded-full px-6 py-2 flex items-center justify-between gap-4 pt-[0px] pb-[0px]" data-id="element-346" data-mp="3hbwjoacs389o">
              <div className="flex items-center gap-2 overflow-hidden h-5" data-id="element-347" data-mp="3qckw50mix0kg">
                <AnimatePresence mode="wait" data-id="element-348" data-mp="3qai1g3afej9e">
                  <motion.div key={stickyInfoIndex} initial={{
                y: 20,
                opacity: 0
              }} animate={{
                y: 0,
                opacity: 1
              }} exit={{
                y: -20,
                opacity: 0
              }} transition={{
                duration: 0.5
              }} className="flex items-center gap-2" data-id="element-349" data-mp="3vawanonrjz90">
                    <div className={cn('w-2 h-2 rounded-full animate-pulse', stickyInfoIndex === 0 ? 'bg-green-500' : 'bg-red-500')} data-id="element-350" data-mp="hxjd625cnwwb" />
                    <span className="md:text-xs font-bold text-[#9D4D60] uppercase tracking-widest whitespace-nowrap text-[7px]" data-id="element-351" data-mp="mwnlyrod3sm4">
                      {stickyInfoIndex === 0 ? `${viewers} personas mirando` : `¡Solo quedan ${coupons} cupos!`}
                    </span>
                  </motion.div>
                </AnimatePresence>
              </div>
              <button onClick={scrollToPurchase} className="bg-gradient-to-r from-[#B76E79] to-[#9D4D60] text-white text-[10px] md:text-xs font-black px-5 py-2 rounded-full shadow-md hover:scale-105 active:scale-95 transition-all uppercase tracking-tighter flex items-center gap-1" data-id="element-352" data-mp="2nylro1yl23xd">
                Ver Oferta
                <ArrowRight size={12} data-id="element-353" data-mp="3bog109jp1acv" />
              </button>
            </div>
          </motion.div>}
      </AnimatePresence>

      {/* Modals & Notifications */}
      <AnimatePresence data-id="element-354" data-mp="36n0iao4znfxn">
        {purchaseNotify && <motion.div initial={{
        opacity: 0,
        x: -50
      }} animate={{
        opacity: 1,
        x: 0
      }} exit={{
        opacity: 0,
        x: -50
      }} className="fixed bottom-6 left-6 z-[100] bg-white/70 backdrop-blur-md p-3 rounded-2xl shadow-xl border border-white/40 flex items-center gap-3 max-w-[240px]" data-id="element-355" data-mp="1h93sj880oldr">
            <div className="w-8 h-8 bg-[#FDF2F2] rounded-full flex items-center justify-center text-sm shadow-inner shrink-0" data-id="element-356" data-mp="3swh3wfcws1ey">
              💄
            </div>
            <div className="min-w-0" data-id="element-357" data-mp="3j6dxndgs0qyo">
              <p className="text-[11px] font-bold text-[#9D4D60] leading-tight truncate" data-id="element-358" data-mp="3j5clt6rxs0fw">
                {purchaseNotify.name} de {purchaseNotify.city}
              </p>
              <p className="text-[10px] text-slate-500 leading-tight" data-id="element-359" data-mp="3a7k6w3q4mut1">
                Adquirió Cosmética Viva
              </p>
            </div>
          </motion.div>}

        {showSuccessModal && <div className="fixed inset-0 z-[200] flex items-center justify-center p-6 bg-black/60 backdrop-blur-sm" data-id="element-360" data-mp="309mj1hc6j00y">
            <motion.div initial={{
          scale: 0.9,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} className="bg-white p-8 rounded-[2rem] max-w-sm w-full text-center shadow-2xl" data-id="element-361" data-mp="ug4oe4mvwfnj">
              <div className="w-20 h-20 bg-green-100 text-green-600 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-362" data-mp="9o7th01ppkob">
                <MessageCircle size={40} data-id="element-363" data-mp="3vx9175g7ppmj" />
              </div>
              <h3 className="text-2xl font-bold mb-2" data-id="element-364" data-mp="3vzv6szjjlv24">
                ¡Gracias por tu comentario!
              </h3>
              <p className="text-slate-600 mb-8" data-id="element-365" data-mp="3mx3yh8lyrfep">
                Tu opinión ayuda a la comunidad.
              </p>
              <button onClick={() => setShowSuccessModal(false)} className="w-full bg-[#2D5A27] text-white py-4 rounded-xl font-bold" data-id="element-366" data-mp="3i5u6w2guu206">
                Cerrar
              </button>
            </motion.div>
          </div>}
      </AnimatePresence>
    </div>;
}